import Survicate from '@survicate/survicate-web-package';
import { useCallback } from 'react';

/**
 * Custom hook for triggering Survicate events without any backend dependency.
 * It directly invokes a Survicate event and handles survey completion/closure
 * without reporting back to the application's backend.
 *
 * @param {string} eventName The name of the Survicate event to trigger.
 */
export function useSurvicateEvent(eventName: string) {
  const triggerSurveyEvent = useCallback(() => {
    if (!eventName) {
      return;
    }

    const handleComplete = () => {
      Survicate.removeEventListener(Survicate.ApiEvent.surveyCompleted);
      Survicate.removeEventListener(Survicate.ApiEvent.surveyClosed);
    };

    Survicate.addEventListener(Survicate.ApiEvent.surveyCompleted, handleComplete);
    Survicate.addEventListener(Survicate.ApiEvent.surveyClosed, handleComplete);
    Survicate.invokeEvent(eventName);
  }, [eventName]);

  return {
    triggerSurveyEvent,
  };
}
